import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_uLearn/layout/core';
import Students from './students';
const profileBreadCrumbs: Array<PageLink> = [
  {
    title: 'Students',
    path: 'Students',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const index = () => (
  <Routes>
    <Route
      element={
        <>
          <Outlet />
        </>
      }
    >
      <Route
        path="*"
        element={<Navigate to="/error/404" />}
      />
      <Route
        // path=""
        index
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Students</PageTitle>
            <Students />
          </>
        }
      />
    </Route>
  </Routes>
);
export default index;
